export default {
  data() {
    return {
      countryKeyCode: '+1',
      country: '+124', // 所在地
    };
  },
  watch: {
    countryObj: {
      handler() {
        const v = this.defaultCountryCode;
        if (v && this.countryKeyCode === '') {
          this.countryKeyCode = v;
        }
        if (!this.defaultCountryCodeReal
            && !this.country
            && v
            && this.countryMap
            && this.countryMap[v]) {
          this.country = this.countryMap[v].code;
        }
        if (this.defaultCountryCodeReal && this.country === '') {
          this.country = this.defaultCountryCodeReal;
        }
      },
    },
    defaultCountryCodeReal: {
      handler(v) {
        if (v && this.country === '') {
          this.country = v;
        }
      },
      immediate: true,
    },
    defaultCountryCode: {
      handler(v) {
        if (v && this.countryKeyCode === '') {
          if (this.defaultCountryCodeReal) {
            this.countryKeyCode = this.countryListKeyObj[
              this.defaultCountryCodeReal].keyCode;
          } else {
            this.countryKeyCode = v;
          }
        }
        if (
          !this.defaultCountryCodeReal
          && !this.country
          && v
          && this.countryMap
          && this.countryMap[v]
        ) {
          this.country = this.countryMap[v].code;
        }
      },
      immediate: true,
    },
  },
  computed: {
    countryListKeyObj() {
      const list = {};
      this.countryObj.list.forEach((item) => {
        list[item.code] = {
          code: item.code,
          keyCode: item.keyCode,
          value: item.value.split(' ')[0],
        };
      });
      return list;
    },
    // 国家渲染列表
    countryList() {
      return this.countryObj.list;
    },
    countryListMoy() {
      const arr = [];
      this.countryObj.list.forEach((item) => {
        arr.push({
          code: item.code,
          keyCode: item.keyCode,
          value: item.value.split(' +')[0],
        });
      });
      return arr;
    },
    countryMap() {
      return this.countryObj.countryMap;
    },
    countryRealMap() {
      return this.countryObj.countryRealMap;
    },
    countryObj() {
      return this.$store.state.baseData.countryObj;
    },
    // 默认区号
    defaultCountryCode() {
      // 原来有默认配置,不过这个地方找不到 先注掉
      // return this.$store.state.baseData.defaultCountryCode;
      return this.countryKeyCode; // 默认加拿大
    },
    defaultCountryCodeReal() {
      // 原来有默认配置,不过这个地方找不到 先注掉
      // return this.$store.state.baseData.defaultCountryCodeReal;
      return this.country; // 默认加拿大
    },
  },
  methods: {
    // 国家列表change
    countryChange(item) {
      console.log(item, 'item')
      this.country = item.code;
      this.countryKeyCode = item.keyCode;
    },
  },
};
